//en.js

// import zhLocale from 'element-ui/lib/locale/lang/zh-en'
import header from './en/header'
import footer from './en/footer'
import main from './en/main'
import plist from './en/plist'
import pdetail from './en/pdetail'
import login from './en/login'
import forget from './en/forget'
import register from './en/register'
import center from './en/center'
import cmain from './en/cmain'
import cgoods from './en/cgoods'
import cbranch from './en/cbranch'
import caddress from './en/caddress'
import cdepartment from './en/cdepartment'
import cmember from './en/cmember'
import cdata from './en/cdata'
import cpwd from './en/cpwd'
import cqcart from './en/cqcart'
import cqorder from './en/cqorder'
import cart from './en/cart'
import costatus from './en/costatus'
import corder from './en/corder'
import csales from './en/csales'
import cmonth from './en/cmonth'
import ccoll from './en/ccoll'
import ccall from './en/ccall'
import getattr from './en/getattr'
import breadcrumb from './en/breadcrumb'
import instructions from './en/instructions'
import service from './en/service'
import repair from './en/repair'

const en = {
    message: {
        header,
        footer,
        main,
        plist,
        pdetail,
        login,
        forget,
        register,
        center,
        cmain,
        cgoods,
        cbranch,
        caddress,
        cdepartment,
        cmember,
        cdata,
        cpwd,
        cqcart,
        cqorder,
        cart,
        costatus,
        corder,
        csales,
        cmonth,
        ccoll,
        ccall,
        getattr,
        breadcrumb,
        instructions,
        service,
        repair
    },
    public: {
        confirmBtn: "確定",
        cancelBtn: "取消",
        submitBtn: "提交",
        modifyBtn: "修改",
        delBtn: "刪除",
        searchBtn: "查詢",
        quoteCart: "報價車",
        shoppingCart: "購物車",
        notLogin: "您還未登錄，請先登錄！",
        goLogin: "去登錄",
        delSucc: "刪除成功！",
        addSucc: "添加成功！",
        modifySucc: "修改成功！",
        remarks: "剩餘可分配額度：{balance}",
        radio1: "是",
        radio2: "否",
        authorityQuote: "您沒有報價權限，請聯繫管理員！",
        authorityOrder: "您沒有下單權限，請聯繫管理員！",
        keyWord: "請輸入關鍵字"
    }
    // ...zhLocale
}

export default en